import { Component, OnInit } from '@angular/core';
import gsap from 'gsap';

@Component({
  selector: 'app-anim-internet',
  templateUrl: './anim-internet.component.html',
  styleUrls: ['./anim-internet.component.scss']
})
export class AnimInternetComponent implements OnInit {
  speed = 1;

  tlWifi = gsap.timeline({ repeat: -1 });
  tlCircle = gsap.timeline({ repeat: -1 });

  constructor() { }

  ngOnInit(): void {
    this.animateWifi();
    this.animateCircle();
    // this.animateBackground();
  }

  ngOnDestroy(): void{
    this.tlWifi.kill();
    this.tlCircle.kill();
  }

  animateCircle() {
    // let tl = gsap.timeline({ repeat: -1 });

    this.tlCircle.from('.dotted-circle-1 ellipse', {
      attr: { rx: 100, ry: 100 }, // 128
      opacity: 0,
      duration: 0.5 * this.speed
    }).from('.dotted-circle-2 ellipse', {
      attr: { rx: 170, ry: 170 }, // 208
      opacity: 0,
      duration: 0.5 * this.speed
    }).from('.dotted-circle-3 ellipse', {
      attr: { rx: 250, ry: 250 }, // 303
      opacity: 0,
      duration: 1 * this.speed
    })
  }

  animateBackground() {
    let tl = gsap.timeline({ repeat: -1 });

    tl.to('.anim-bg .dotted-circle-3', {
      attr: { rx: 340, ry: 340 },
      duration: 3 * this.speed,
      opacity: 0.2,
      delay: 0.25 * this.speed
    })
    .to('.anim-bg .dotted-circle-2', {
      attr: { rx: 340, ry: 340 },
      opacity: 0.2,
      duration: 3 * this.speed,
    }, 1.25 * this.speed)
  }

  animateWifi() {
    // let tl = gsap.timeline({ repeat: -1 });
    let el = '.wifi .line-';

    this.tlWifi.to('.wifi .line-1', { duration: 0.3, fill: '#aefdf4' }).set(el+'1', { fill: '#284f8f' });
    this.tlWifi.to('.wifi .line-2', { duration: 0.3, fill: '#aefdf4' }, 0.25).set(el+'2', { fill: '#284f8f' });
    this.tlWifi.to('.wifi .line-3', { duration: 0.3, fill: '#aefdf4' }, 0.5 ).set(el+'3', { fill: '#284f8f' });
    this.tlWifi.to('.wifi .line-4', { duration: 0.3, fill: '#aefdf4' }, 0.75);
  }
}
